import React, { Component } from 'react';
import {
    AirlineListItem,
    AirlineGridItem,
    Filter
} from './index.jsx';
import {orderby} from 'lodash';
import I18 from '../../shared/I18';

export default class AirlineList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mode: this.props.mode,
            data: this.props.data,
            sorting: Filter.ORDER_ALPHABETICAL_ASC
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.mode !== this.state.mode) {
            this.setState({ mode: nextProps.mode });
        }
        if (nextProps.sorting !== this.state.sorting) {
            this.setState({ sorting: nextProps.sorting });
        }
    }

    get orderDirections() {
        switch (this.state.sorting) {
            case Filter.ORDER_ALPHABETICAL_DESC:
                return ['desc', 'desc'];
            case Filter.ORDER_RATING_DESC:
                return ['desc', 'asc'];
            case Filter.ORDER_RATING_ASC:
                return ['asc', 'asc'];
            default:
                return ['asc', 'desc'];
        }
    }

    get airlines() {

        let filtered = this.state.data;
        if (this.props.filter.trim() !== '') {
            const filter = this.props.filter.toLowerCase();
            filtered = this.state.data.filter(a => {
                return a.iataCode.toLowerCase() == filter ||
                    a.title.toLowerCase().indexOf(filter) >= 0;
            });
        }
        const orderFields = (this.state.sorting == Filter.ORDER_RATING_ASC || this.state.sorting == Filter.ORDER_RATING_DESC) ?
            ['rating', 'sortingTitle'] :
            ['sortingTitle', 'rating'];

		filtered = _.orderBy(filtered, orderFields, this.orderDirections);
		return filtered;
    }

    render() {

        var airlines = this.airlines;
        var resultNodes = null;
        const that = this;

        if (airlines) {
            resultNodes = airlines.map((result, i) => {
                if (that.state.mode == 'grid') {
                    return (
                        <AirlineGridItem
                            key={i}
                            airline={result.airline}
                            title={result.title}
                            logo={result.logo}
                            image={result.image}
                            rating={result.rating}
                            deals={result.deals}
                            iataCode={result.iataCode}
                            />
                    )
                } else {
                    return (
                        <AirlineListItem
                            key={i}
                            airline={result.airline}
                            title={result.title}
                            iataCode={result.iataCode}
                            phone={result.phone}
                            website={result.website}
                            websiteName={result.websiteName}
                            rating={result.rating}
                        />
                    );
                }
            });
        }
        if (this.state.mode == 'grid') {
            return (
                <div className="row">
					<div className="jb-image-teaser-wrapper">
						{resultNodes}
					</div>
                </div>
            )
        }
        return (
            <table className="jb-filter-list-view">
                <thead>
                <tr>
                    <td><I18 textkey="airlineListApp.airlinelist.airline" defaultValue="Airline"/>Airline</td>
                    <td className="hidden-xs"><I18 textkey="airlineListApp.airlinelist.code" defaultValue="Code"/></td>
                    <td className="hidden-xs"><I18 textkey="airlineListApp.airlinelist.telefon" defaultValue="Telefonnummer"/></td>
                    <td className="hidden-sm hidden-xs"><I18 textkey="airlineListApp.airlinelist.website" defaultValue="Website"/></td>
                    <td className="text-right"><I18 textkey="airlineListApp.airlinelist.jetbeds" defaultValue="jetbeds"/></td>
                </tr>
                </thead>
                <tbody className="jb-text-secondary">
                {resultNodes}
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./AirlineListApp/components/AirlineList.jsx